export default [
  {
    text: 'Segmento',
    value: 'segmento'
  },
  {
    text: 'Fornecedor',
    value: 'nome_fornecedor',
    ocultar_em_produtos_combinados: true
  },
  {
    text: 'Cod. Interno',
    value: 'id_produto'
  },
  {
    text: 'Cod. Fornecedor',
    value: 'cod_produto'
  },
  {
    text: 'Número Original',
    value: 'numero_original'
  },
  {
    text: 'Nome do Produto',
    value: 'nome_produto'
  },
  {
    text: 'Necessidade DRP',
    value: 'existe_necessidade_drp',
    ocultar_em_produtos_combinados: true
  },
  {
    text: 'Última Venda',
    value: 'data_ultima_venda'
  },
  {
    text: 'Última Compra',
    value: 'data_ultima_compra'
  },
  {
    text: 'Preço de Custo',
    value: 'preco_custo'
  },
  {
    text: 'Preço de Venda',
    value: 'preco_venda'
  },
  {
    text: 'Nível de Importância',
    value: 'nivel_servico'
  },
  {
    text: 'Nível de Estoque',
    value: 'nivel_estoque'
  },
  {
    text: 'ID Pedido Trânsito',
    value: 'lista_pedidos_em_aberto'
  },
  {
    text: 'Ações',
    value: 'opcoes',
    width: '5px',
    sortable: false
  }
]
